import { Tooltip, TooltipProps } from "@material-ui/core";
import { IconButtonProps } from "@material-ui/core/IconButton";
import { createStyles, makeStyles } from "@material-ui/styles";
import qs from "qs";
import * as React from "react";

import { RelodeTheme } from "..";
import { mergeClasses, useRouter } from "../..";
import { MessageIcon } from "../../assets/icons";
import { MessageBoxOptionsEnum, MessageSearchCriteria } from "../../features";
import { PageActionButton } from "../page";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                padding: theme.spacing(1),
                "& svg": {
                    alignSelf: "center",
                },
            },
        }),
    { name: "MessageListingIconButton" }
);

interface InnerMessageListingIconButtonProps {
    classes?: Partial<ReturnType<typeof useStyles>>;
    // These are actually TooltipProps. They should be the most commonly modified when using this component.
    // We are modifying the name here to be more specific than the original provided in ToolTipProps.
    toolTipTitle?: string;
    toolTipPlacement?:
        | "bottom-end"
        | "bottom-start"
        | "bottom"
        | "left-end"
        | "left-start"
        | "left"
        | "right-end"
        | "right-start";
}

interface MessageListingProps {
    jobId?: number;
    jobName?: string;
    candidateId?: number;
    candidateName?: string;
}

type MessageListingIconButtonProps = InnerMessageListingIconButtonProps &
    IconButtonProps &
    MessageListingProps;

export const MessageListingIconButton = (
    props: MessageListingIconButtonProps,
    toolTipProps: TooltipProps
) => {
    const {
        id,
        classes: classesProp,
        candidateId,
        candidateName,
        jobId,
        jobName,
        toolTipTitle = "view messages",
        toolTipPlacement = "bottom-start",
        ...iconButtonProps
    } = props;

    const {
        placement = toolTipPlacement,
        title = toolTipTitle,
        ...rest
    } = toolTipProps;

    const classes = mergeClasses(useStyles({}), classesProp);
    const { history } = useRouter();

    const goToMessageSearch = () => {
        const criteria: MessageSearchCriteria = {
            searchText: "",
            pageIndex: 1,
            pageSize: 25,
            sortField: "createTimestamp",
            sortDir: "desc",
            box: MessageBoxOptionsEnum.AllMessages.name,
            contextJobId: jobId,
            contextJobName: jobName,
            contextUserId: candidateId,
            contextUserName: candidateName,
        };
        history.push(
            `/messages${qs.stringify(criteria, {
                skipNulls: true,
                addQueryPrefix: true,
                sort: (a, b) => a.localeCompare(b),
            })}`
        );
    };

    return (
        <>
            <Tooltip
                placement={placement}
                title={title}
                disableFocusListener
                {...rest}
            >
                <span>
                    <PageActionButton
                        id={id}
                        className={classes.root}
                        color="primary"
                        onClick={goToMessageSearch}
                        {...iconButtonProps}
                    >
                        <MessageIcon />
                    </PageActionButton>
                </span>
            </Tooltip>
        </>
    );
};
